import FormSubmission from "@/types/FormSubmission.interface"
import helpers from "@/utility/helpers"

interface State {
    formSubmissions: object
}

const defaults = () => {
    return {
        //  A list of our submissions referenced by each form id
        formSubmissions: {}
    }
}

export default {
    state: defaults(),
    mutations: {
        formSubmissionsPush (state: State, submissions: FormSubmission[]): void {
            for (const submission of submissions) {
                //  Check for a current list
                const list = state.formSubmissions[submission.form_id]

                //  If the list does NOT exist, do nothing
                if (!list) return

                //  Else, add the submission to the list
                helpers.addItemById(submission, state.formSubmissions[submission.form_id], true)
            }
        },
        formSubmissionsSet (state: State, submissions: FormSubmission[]): void {
            for (const submission of submissions) {
                //  Check for a current list
                const list = state.formSubmissions[submission.form_id]

                //  If the list does NOT exist, initialize it
                if (!list) state.formSubmissions[submission.form_id] = []

                //  Add the submission to the list
                helpers.addItemById(submission, state.formSubmissions[submission.form_id])
            }
        },
        formSubmissionsRemove (state: State, ids: number[]): void {
            //  Grab all of our current form submissions
            const submissions = state.formSubmissions

            //  Iterate through our submissions
            for (const [form, subs] of Object.entries(submissions)) {
                //  Filter out all submissions that are removed
                let filtered = subs.filter((x: FormSubmission) => !ids.includes(x.id))

                //  Replace the current with the submissions filtered
                state.formSubmissions[form] = filtered
            }
        },
        formSubmissionsReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        formSubmissionsDelete ({ commit, getters }, payload: object) {
            //  Assemble the API endpoint
            const url = `${getters.api}/form-submissions/delete`

            //  Send the request
            return window.axios.post(url, payload).then(response => {
                //  Remove from our form submissions
                commit('formSubmissionsRemove', response.data.deleted_ids)

                //  Remove from our form submissions view
                commit('formsViewSubmissionsRemove', response.data.deleted_ids)

                //  Return the response
                return response.data
            }).catch(() => null)
        },
        formSubmissionsFind ({ getters }, id: number): Promise<FormSubmission> {
            //  Assemble the API endpoint
            const url = `${getters.api}/form-submissions/${id}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return our found submission
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        formSubmissions (state: State): object {
            return state.formSubmissions
        }
    }
}